<template>
  <div class="hello">
    <form method="POST" ref="hid_cred" action="/hid_approve">
      <div class="error" v-if="msg.length > 0">
        {{ msg }}
      </div>
      <h3>Учетная запись</h3>
      <input v-model="hidUsername" class="user-input" type="text" name="hid_username" autofocus>
      <span v-if="hidType===0">
        <h3 class="underline-dashed" @click="hidType=1"
            style="-moz-user-select: none; -webkit-user-select: none; -ms-user-select:none; user-select:none;-o-user-select:none;">Одноразовый код</h3>
        <div style="width: 372px; margin: auto;">
        <v-otp-input
            ref="otpInput"
            input-classes="otp-input"
            separator=""
            :num-inputs="6"
            :is-input-num="true"
            @on-complete="handleOnComplete"
        />
        </div>
      </span>
      <span v-if="hidType===1">
        <h3 class="underline-dashed" @click="hidType=0"
            style="-moz-user-select: none; -webkit-user-select: none; -ms-user-select:none; user-select:none;-o-user-select:none;">Пароль</h3>
        <input v-model="hidPassword" class="user-input-password" type="text">
        <button class="submit-button" @click.prevent="handlePassword">&#8594;</button>
      </span>
      <input type="hidden" name="hid_pin" :value="hidPin">
    </form>
  </div>
</template>

<script>
export default {
  name: 'LoginForm',
  data: function () {
    return {
      msg: "",
      hidUsername: "",
      hidPin: "",
      hidPassword: "",
      hidType: 0,
    }
  },
  methods: {
    handlePassword() {
      console.log("Password entered:", this.hidPassword)

      if (this.hidPassword.length > 3) {
        this.hidPin = this.hidPassword

        this.$nextTick(() => {
          this.$refs.hid_cred.submit()
        });
      }
    },
    handleOnComplete(value) {
      console.log("OTP completed:", value)
      this.hidPin = value
      this.$nextTick(() => {
        this.$refs.hid_cred.submit()
      });

      // this.$http.post(
      //     '/hid_approve',
      //     {
      //       hid_username: this.hidUsername,
      //       hid_pin: value,
      //     }
      // ).then((response) => {
      //   console.log("OK:" + response.status)
      // }).catch((error) => {
      //   if (error) {
      //     console.log(error.status)
      //   }
      // });

    },
    updateMessage() {
      let search = window.location.search;
      if (search === "?error") {
        this.msg = "Неправильное имя учетной записи или одноразовый код, попробуйте ввести еще раз";
      }
    }
  },
  beforeMount() {
    this.updateMessage()
  }
}
</script>

<style>
h3 {
  margin: 40px 0 0;
}

.error {
  margin: 40px 0 0;
  color: darkred;
  font-size: 20px;
}

.underline-dashed {
  text-decoration: underline;
  text-decoration-style: dotted;
  cursor: pointer;
}

.submit-button {
  width: 50px;
  height: 50px;
  margin: 5px 5px;
  font-size: 20px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  text-align: center;
}

.user-input {
  width: 352px;
  height: 40px;
  padding: 5px;
  margin: 10px 10px;
  font-size: 20px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  text-align: center;
}

.user-input-password {
  width: 297px;
  height: 40px;
  padding: 5px;
  margin: 10px 10px;
  font-size: 20px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  text-align: center;
}

.otp-input {
  width: 40px;
  height: 40px;
  padding: 5px;
  margin: 10px 5px;
  font-size: 20px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  text-align: center;
}

input:focus {
  outline: none !important;
  border-color: #0057B7;
  box-shadow: 0 0 5px #0057B7;
}

/* Background colour of an input field with value */
.otp-input.is-complete {
  background-color: #f4f4f4;
}

.otp-input::-webkit-inner-spin-button,
.otp-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input::placeholder {
  font-size: 15px;
  text-align: center;
  font-weight: 600;
}
</style>
